import React from "react";
import "./Home.css";

function Shower() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>SHOWER</h1>
            <p className="home-subtitle">
              <img className="brandImg" src="/itc.avif" />
              <br />
              Hot & Cold Stainless Steel Shower
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1BQTfYwJkBn3X1JwjptoxZQ6AtKb9gadK/preview"></iframe>
        </div>
      </div>
      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          The outdoor shower is located at the back of the van on the left side
          under the bed.
        </p>
        <p className="tealText">
          To supply water to the shower head, twist the knob inside the shower
          container to the left. It will pop out, showing the threads. This
          means water is being supplied to the shower head. Turn the knob to the
          right for cold water, to the left for hot water.
        </p>
        <p className="tealText">
          Once the knob inside the container is activated, you can use the valve
          on the actual shower head to turn the water on and off. Turn to the
          left for water, to the right to turn off the water.
        </p>
        <p className="tealText">
          There’s a magnetic shower head holder on the inside of the back door.
          You can move this around anywhere on the door that feels comfortable
          for holding the shower head.
        </p>
        <p className="tealText">
          Be careful not to point the shower head into the van!
        </p>
        <p className="tealText">
          A magnetic shower curtain is located in the storage area under the
          right side of the bed. It will stretch across the open back doors to
          create a private showering area.
        </p>
        <p className="tealText">
          When finished using the shower, push the knob inside the container
          closed. Empty out any extra water in the shower head before retracting
          the hose. The shower head has to be pushed slightly into the cutout in
          the container in order for the container door to fully latch.
        </p>
        <p className="tealText">
          If there is ever any water leaking out of the shower system, turn off
          the valves on the red and blue PEX pipes located under the sink.
        </p>
      </div>

      <div className="home-text-content">
          <div className="title-text-cont">
          <h1 style={{ paddingTop: ".7em" }}>Shower Curtains</h1>
          <p className="home-subtitle">
              <br />
              Adjustable 85x57inch Magnetic Curtain w/ Side Privacy Panels
            </p>
          </div>
        </div>
      <div className="iframe-container">
        <iframe
          className="responsive-iframe"
          src="https://drive.google.com/file/d/1cT8OfArygL89wX0lnmKYkLm447VXH5YT/preview"
        ></iframe>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          The shower curtains are located in the storage underneath the bed, by the passenger side tail light
        </p>
        <p className="tealText">
          There are 2 smaller curtains to cover up the gaps between the van and the doors, and then a larger curtain to go between the two open rear doors
        </p>
        <p className="tealText">
          Magnets attach all 3 curtains to the doors. The main curtain has a drawstring to lengthen / tighten it. 
        </p>
        <p className="tealText">
          Please make sure you dry the curtains before putting them back in their stuff sack
        </p>
      </div>

      

      <div className="movCont">
        <img src="/shower.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default Shower;
